import { apiClient } from "@/core/api/httpClient";

export default {
  orgByMonth: async (filter) => {
    return await apiClient
      .get(`revenue-report/monthly`, {
        params: filter,
      })
      .then((json) => json.data);
  },
  businessGrByMonth: async (filter) => {
    const params = filter ? { $filter: filter } : {};
    return await apiClient
      .get(`revenue-report/monthly`, {
        params,
      })
      .then((json) => json.data);
  },
  productRevenue: async (param) => {
    return await apiClient
      .get(`revenue-report/product`, {
        params: {
          startDate: param.rangeValue.from,
          endDate: param.rangeValue.to,
          businessGroupId: param.businessGroup,
          organizationId: param.organization,
        },
      })
      .then((json) => json.data);
  },
};
